import { Badge, Menu } from "antd";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { findModel } from "../../components/templates/main-template/MainTamplate.utils";
import { modelPath, useModels, useTasksModelPath } from "./navigation";
import { useTasksStats } from "./useTasksStats";

// Model navigation shared by the desktop sidebar and the mobile drawer.
export const ModelsMenu: React.FC<{ onNavigate?: () => void }> = ({
  onNavigate,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const models = useModels();
  const tasksPath = useTasksModelPath();
  const { total } = useTasksStats();

  const { model } = findModel(models, location.pathname.slice(1));

  const items = [...models]
    .sort((a: any, b: any) => a.position - b.position)
    .map((m: any) => {
      const path = modelPath(m);
      const isTasks = path === tasksPath;
      return {
        key: m.id.toString(),
        label:
          isTasks && total > 0 ? (
            <span>
              {m.name} <Badge count={total} size="small" />
            </span>
          ) : (
            m.name
          ),
        onClick: () => {
          navigate(path);
          onNavigate?.();
        },
      };
    });

  return (
    <Menu
      mode="inline"
      selectedKeys={model ? [model.id.toString()] : []}
      items={items}
      style={{ border: "none", background: "transparent" }}
    />
  );
};
